import React from "react";
import { ShieldAlert } from "lucide-react";
import { usePresentationMode } from "./PresentationContext";
import NoteableItem from "./NoteableItem";

const PRIORITY_ORDER = ["P0", "P1", "P2"];
const PRIORITY_STYLE = {
  P0: { label: "Highest priority", accent: "#B42318" },
  P1: { label: "Important", accent: "#B45309" },
  P2: { label: "When we get to it", accent: "#5C6E83" },
};

export const BlockersPanel = ({ items = [] }) => {
  const presenting = usePresentationMode();
  if (!items.length) {
    return (
      <div className="showcase-card p-6" data-testid="blockers-panel-empty">
        <p className="text-sm text-muted-foreground">Nothing is blocking us right now.</p>
      </div>
    );
  }

  const grouped = PRIORITY_ORDER.map((p) => ({
    priority: p,
    label: PRIORITY_STYLE[p].label,
    accent: PRIORITY_STYLE[p].accent,
    items: items.filter((i) => i.priority === p),
  })).filter((g) => g.items.length > 0);

  return (
    <div className="showcase-card p-5 sm:p-6" data-testid="blockers-panel">
      <div className="flex items-center gap-2 mb-1">
        <ShieldAlert size={18} strokeWidth={2} style={{ color: "#3F4F66" }} aria-hidden />
        <h2 className="font-heading text-xl sm:text-2xl" style={{ color: "#1F1F1F", fontWeight: 600 }}>
          What needs a decision or a helping hand
        </h2>
      </div>
      <p className="text-xs sm:text-sm text-muted-foreground mb-4">
        Colour labels show which products are affected.{!presenting && " Click a point to record feedback."}
      </p>
      <div className="space-y-5">
        {grouped.map((group) => (
          <div key={group.priority}>
            <div className="eyebrow mb-1.5" style={{ color: group.accent }}>
              {group.label}
            </div>
            <div className="space-y-0.5">
              {group.items.map((item, idx) => (
                <NoteableItem
                  key={item.key || idx}
                  item={item}
                  index={idx}
                  numbered={false}
                  accent={group.accent}
                  section="blockers"
                  showPills
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlockersPanel;
